import { useQuery } from '@atlassian/conversation-assistant-service/common/utils/use-query';

export type ApiWorkflowUsagesResponse = {
	statusId: string;
	workflows: {
		nextPageToken: string;
		values: {
			id: string;
		}[];
	};
};

const fetchStatusWorkflowUsages = async (
	cloudId: string,
	statusId: string,
): Promise<ApiWorkflowUsagesResponse> => {
	const response = await fetch(
		`/gateway/api/ex/jira/${cloudId}/rest/api/3/statuses/${statusId}/workflowUsages?maxResults=2`,
		{
			headers: {
				Accept: 'application/json',
			},
		},
	);

	if (!response.ok) {
		throw new Error('Failed to fetch Jira status workflow usages');
	}

	return response.json();
};

type UseStatusWorkflowUsagesOptions = {
	cloudId: string;
	statusId: string;
	enabled: boolean;
};

export const useStatusWorkflowUsages = ({
	cloudId,
	statusId,
	enabled,
}: UseStatusWorkflowUsagesOptions): {
	isUsedInOtherWorkflows: boolean;
	hasError: boolean;
	isFetching: boolean;
} => {
	const { data, error, isFetching } = useQuery({
		queryKey: ['status-workflow-usages', cloudId, statusId],
		queryFn: () => fetchStatusWorkflowUsages(cloudId, statusId),
		enabled,
	});

	return {
		isUsedInOtherWorkflows: (data?.workflows.values.length ?? 0) > 1,
		hasError: error !== null,
		isFetching,
	};
};
